import { render, staticRenderFns } from "./CardHolderTable.vue?vue&type=template&id=74c7c8a4&scoped=true&"
import script from "./CardHolderTable.vue?vue&type=script&lang=js&"
export * from "./CardHolderTable.vue?vue&type=script&lang=js&"
import style0 from "./CardHolderTable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CardHolderTable.vue?vue&type=style&index=1&id=74c7c8a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c7c8a4",
  null
  
)

export default component.exports